import { useState } from 'react';
import {useDebounce} from "@uidotdev/usehooks";
import useDidMountEffect from "./useDidMountEffect";
import {useDealContext} from "../contexts/DealContext";

const useFeeStateHook = (fee) => {
    const { dealState, setDealStateWithUpdate, updateDealResponse } = useDealContext()
    const [feeState, setFeeState] = useState(fee)

    const debouncedFeeState = useDebounce(feeState, 1)

    const setFeeStateWithUpdate = (newState, update = true) => {
        return setFeeState({...feeState, ...newState, _update: update})
    }

    useDidMountEffect(function updateFeeFromBackend(){
        setFeeState({...fee, _update: false})
    }, [])

    useDidMountEffect(function updateDealState(){
        if (feeState) {
            let newDealState = structuredClone(dealState)
            let allFees = newDealState.formatted_quote.fees

            allFees.forEach((el, index, array) => {
                if (feeState.id === el.id) {
                    array[index] = feeState
                }
            })

            newDealState.formatted_quote.fees = allFees
            setDealStateWithUpdate(newDealState, feeState?._update)
        }
    }, [debouncedFeeState])

    useDidMountEffect(function updateQuoteFromBackend(){
        if (
            updateDealResponse?.data?.data &&
            !updateDealResponse.loading &&
            !updateDealResponse.error &&
            feeState
        ) {
            const newDealState = updateDealResponse?.data?.data

            const feeFromBackend = newDealState.formatted_quote.fees.find(f => String(f.id) === String(feeState.id))

            if (feeFromBackend) {
                setFeeState({...feeFromBackend, _update: false})
            }
        }
    }, [updateDealResponse])


    return [feeState, setFeeStateWithUpdate]
}

export default useFeeStateHook;